<div *ngIf="showLayout">
    <app-asahi-navbar></app-asahi-navbar>
    <app-asahi-banner></app-asahi-banner>
    <app-asahi-whytochoose></app-asahi-whytochoose>
    <app-asahi-product></app-asahi-product>
    <app-asahi-footer></app-asahi-footer>
</div>
<router-outlet></router-outlet>